import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: ['en', 'he'],
        fallbackLng: 'en',
        defaultNS: 'translation',
        ns: ['translation'],

        backend: {
            // The bundle is content-hashed but the locale files are not, so a
            // browser holding an older translation.json renders raw keys
            // ("importPlan.importShort") next to fresh UI code. Stamping the
            // build id on the URL ties the two together.
            loadPath: `/locales/{{lng}}/{{ns}}.json?v=${process.env.REACT_APP_BUILD_ID || 'dev'}`,
        },

        detection: {
            // Detection order: localStorage → navigator.language → html[lang]
            order: ['localStorage', 'navigator', 'htmlTag'],
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage'],
        },

        interpolation: {
            // React already escapes values — no need for i18next escaping
            escapeValue: false,
        },

        react: {
            useSuspense: true,
        },
    });

export default i18n;
